import styled from 'styled-components';

export const A = styled.a`
  text-decoration: none;
`;
